<template>
  <div>
		<v-layout row wrap justify-end class="header-booking-data">
			<v-flex xs2 xl-2 lg2 text-xs-right>
				<v-select
					v-bind:items="subsidiaries"
					class="filter-select"
					item-text="name"
					item-value="id"
					v-model="idSubsidiary"
					hide-details
					single-line
					bottom
					@input="loadData"
					>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout d-flex row wrap ml-2 align-center>
			<v-flex xs2 mt-1 pa-0>
				<v-menu
				lazy
				v-model="menuStart"
				transition="scale-transition"
				offset-y
				full-width
				:nudge-left="40"
				class="menu-date-picker"
				max-width="290px">
				<v-text-field
				slot="activator"
				v-model="dateStart"
				label="Picker in menu"
				:disabled="!dateStart"
				prepend-icon="event"
				:append-icon="arrowIconStart"
				single-line
				hide-details
				readonly
				></v-text-field>
				<v-date-picker
				v-model="dateStart"
				no-title
				scrollable
				@input="loadData"
				>
				</v-date-picker>
				</v-menu>
			</v-flex>
			<v-flex xs2 mt-1 pa-0>
				<v-menu
						lazy
						v-model="menuEnd"
						transition="scale-transition"
						offset-y
						full-width
						class="menu-date-picker"
						max-width="290px">
					<v-text-field
						slot="activator"
						label="Picker in menu"
						:append-icon="arrowIconEnd"
						v-model="dateEnd"
						single-line
						hide-details
						readonly
					></v-text-field>
					<v-date-picker
						no-title
						v-model="dateEnd"
						scrollable
						@input="loadData"
						>
					</v-date-picker>
				</v-menu>
			</v-flex>
			<v-flex xs6 text-xs-right>
				<section class="filters-by-time">
					<v-btn 
					v-for="filter in filters" 
					:key="filter.id"
					:class="{'activeBtn': filter.id === value}"
					@click="onDateFilter(filter)"
					:disabled="loading">
					{{filter.value}}
				</v-btn>
				</section>
		</v-flex>
		<v-flex xs12 md2>
			<v-btn type="button" 
				class="btn-action btn-success white--text"
				@click="customButtons">
				<v-icon>print</v-icon>
				Imprimir Reporte
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap mt-3>
			<v-flex xs12>
				<table-run
				:columns="columns"
				:rows="rows"
				:include-delete="false"
				:include-export-to-excel="false"
				:include-search="false"
				:selectable="false"
				class="no-selectable-table no-search-table"
				>
				<template slot="rows" scope="props"  @click="customBtn">
					<td>{{props.row.code}}</td>
					<td>{{props.row.customer ? props.row.customer.data.name : '' }} {{props.row.customer ? props.row.customer.data.lastname : ''}}</td>
					<td>{{props.row.channel ? props.row.channel.data.name : ''}}</td>
					<td>{{props.row.country}}</td>
					<td>{{props.row.bookingRooms.data.roomTypes ? props.row.bookingRooms.data.codeRoomtype : ''}}{{props.row.bookingRooms.data.roomTypes ? props.row.bookingRooms.data.roomTypes.data.name : ''}}</td>
					<td>{{props.row.paymentStatus.name}}</td>
					<td>{{props.row.bookingStart}}</td>
					<td>{{props.row.bookingEnd}}</td>
					<td>{{props.row.totalPerson}}</td>
				</template>
				</table-run>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import TableRun from 'table-run';
import { addDays, format, subDays } from 'date-fns';
import FiltersByTime from '@/components/shared/FiltersByTime';
import helper from '@/shared/helper';

const helperMethods = helper.methods;

function customButtons() {
	this.printReport();
}

async function printReport() {
	const baseUrl = `${process.env.PMS_URL}/report/restaurant`;
	const dateStart = this.dateStart;
	const dateEnd = this.dateEnd;
	const idSubsidiary = this.idSubsidiary;
	const name = 'Reporte Restaurante';
	const responseType = 'blob';
	const cardModel = { loadTable: [{}] };
	const response = await this.$http.post(`${baseUrl}?dateStart=${dateStart}&dateEnd=${dateEnd}&idSubsidiary=${idSubsidiary}`, cardModel, { responseType },
	);
	const blob = helperMethods.generateBlob(response.bodyBlob);
	helperMethods.showDownloadDialog(blob, name, 'pdf');
}


async function loadData() {
	const params = {
		dateStart: this.dateStart,
		dateEnd: this.dateEnd,
		idSubsidiary: this.idSubsidiary,
	};
	const response = await this.$http.get(`${process.env.PMS_URL}/booking-report/restaurat`, { params });
	this.rows = response.data.data;
}

function onDateFilter(filter) {
	this.value = filter.id;
	if (this.value === 1) {
		this.dateEnd = format(addDays(new Date(), 0), 'YYYY-MM-DD');
	} else {
		this.dateEnd = format(addDays(new Date(), 7), 'YYYY-MM-DD');
	}
	this.loadData();
}

function data() {
	return {
		date: format(new Date(), 'YYYY-MM-DD'),
		subsidiary: 0,
		value: 1,
		totalPage: 1,
		currentPage: 1,
		lastPage: 0,
		filters: [
			{ id: 1, value: 'Hoy' },
			{ id: 2, value: 'Semana' },
		],
		columns: [
			{ id: 1, name: '# Rva', code: 'code', isSortable: { down: false, up: false } },
			{ id: 2, name: 'Nombre', code: 'name', isSortable: { down: false, up: false } },
			{ id: 3, name: 'Canal de Rva', code: 'canal', isSortable: { down: false, up: false } },
			{ id: 4, name: 'País', code: 'country', isSortable: { down: false, up: false } },
			{ id: 5, name: 'Hab.', code: 'room', isSortable: { down: false, up: false } },
			{ id: 6, name: 'Estado', code: 'state', isSortable: { down: false, up: false } },
			{ id: 7, name: 'Fec. Entrada', code: 'checkIn', isSortable: { down: false, up: false } },
			{ id: 8, name: 'Fec. Salida', code: 'checkOut', isSortable: { down: false, up: false } },
			{ id: 9, name: '# Huespedes', code: 'huesped', isSortable: { down: false, up: false } },
		],
		rows: [],
		menuStart: false,
		menuEnd: false,
		dateEnd: format(new Date(), 'YYYY-MM-DD'),
		dateStart: format(subDays(new Date(), 0), 'YYYY-MM-DD'),
		subsidiaries: [],
		idSubsidiary: '',
		loading: false,
	};
}

function arrowIconStart() {
	const arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconEnd() {
	const arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function created() {
	this.loadHotels();
}

async function loadHotels() {
	const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
	this.subsidiaries = subsidiaries.data;
	this.idSubsidiary = this.subsidiaries[0].id;
}

export default {
	name: 'restaurant',
	created,
	data,
	components: {
		FiltersByTime,
		TableRun,
	},
	computed: {
		arrowIconStart,
		arrowIconEnd,
	},
	methods: {
		printReport,
		customButtons,
		loadData,
		onDateFilter,
		loadHotels,
	},
};
</script>

<style lang="scss" scoped>
th {
	background-color: map-get($colors, bg-chart);
}

tr:nth-child(odd) {
	background-color: rgba(241, 241, 241, 0.5); 
}

tr:nth-child(even) {
	background-color: white;
}

.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 50px;
		width: calc(100% - 230px);
}
</style>



// WEBPACK FOOTER //
// Restaurant.vue?2e022de0